import PropTypes from 'prop-types';
import { configActions } from 'core/Config';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Container,
    ExpandButton,
    Modal,
    Text
} from 'mol-ui';
import React, { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const FeatureModal = ({
    active,
    allowDelete,
    onSelect,
    onToggle
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const {
        chatbotFeatureList,
        chatbotFeatureListLoading
    } = useSelector('config');

    const [confirmDelete, setConfirmDelete] = useState(undefined);

    useEffect(() => {
        dispatch(configActions.getChatbotFeatureList());
    }, []);

    const onDelete = featureKey => {
        dispatch(configActions.deleteChatbotFeature(featureKey));
        setConfirmDelete(undefined);
    };

    return (
        <Modal active={ active } loading={ chatbotFeatureListLoading } onToggle={ onToggle }>
            <Container>
                <Container flex="1" flexDirection="column" gap="10px">
                    {
                        chatbotFeatureList.map(featureKey => (
                            <Container alignItems="center" flex="1" flexDirection="row" gap="10px" key={ `feature-key-${ featureKey }` }>
                                <Text>{ featureKey }</Text>
                                {
                                    onSelect &&
                                    <ExpandButton
                                        circle
                                        icon="download"
                                        size={ 20 }
                                        onClick={ () => onSelect(featureKey) }
                                    />
                                }
                                {
                                    allowDelete && !confirmDelete &&
                                    <ExpandButton
                                        circle
                                        danger
                                        icon="delete"
                                        size={ 20 }
                                        onClick={ () => setConfirmDelete(featureKey) }
                                    />
                                }
                                {
                                    (confirmDelete === featureKey) &&
                                    <>
                                        <ExpandButton
                                            circle
                                            danger
                                            icon="done"
                                            size={ 20 }
                                            onClick={ () => onDelete(featureKey) }
                                        />
                                        <ExpandButton
                                            circle
                                            icon="cancel"
                                            size={ 20 }
                                            onClick={ () => setConfirmDelete(undefined) }
                                        />
                                    </>
                                }
                            </Container>
                        ))
                    }
                </Container>
                <ButtonFooter margin="10px 0px 0px 0px">
                    <ExpandButton
                        caption={ t('Cerrar') }
                        size={ 100 }
                        width={ 200 }
                        onClick={ onToggle }
                    />
                </ButtonFooter>
            </Container>
        </Modal>
    );
};

FeatureModal.propTypes = {
    active: PropTypes.bool,
    allowDelete: PropTypes.bool,
    onSelect: PropTypes.func,
    onToggle: PropTypes.func
};

export default FeatureModal;
